export const NFT_PREFIX = '@nft/';
export const NFT_OWNER = `${NFT_PREFIX}OWNER`;
export const NFT_BUY = `${NFT_PREFIX}BUY`;
export const NFT_LIST = `${NFT_PREFIX}LIST`;
export const NFT_GET = `${NFT_PREFIX}GET`;
export const NFT_COUNT_IN_STOCK = `${NFT_PREFIX}COUNT_IN_STOCK`;
export const NFT_CLEAR = `${NFT_PREFIX}CLEAR`;
